import React from "react";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

function AppVersionNameCellTemplate({ data }) {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {data.versionName}
            {data.isLatest && (
                <span className="c-tag c-tag--sml c-tag--active--outline u-mar--left--micro">
                    {t("ADMINISTRATION.APP_RELEASE.TAGS.LATEST")}
                </span>
            )}
            {data.isBeta && (
                <span className="c-tag c-tag--sml c-tag--inactive--outline u-mar--left--micro">
                    {t("ADMINISTRATION.APP_RELEASE.TAGS.BETA")}
                </span>
            )}
        </React.Fragment>
    );
}

AppVersionNameCellTemplate.propTypes = {
    data: PropTypes.object.isRequired,
};

export default AppVersionNameCellTemplate;
